import { render, staticRenderFns } from "./AdminUsersEditBasicView.vue?vue&type=template&id=364994ff&scoped=true&"
import script from "./AdminUsersEditBasicView.vue?vue&type=script&lang=js&"
export * from "./AdminUsersEditBasicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364994ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364994ff')) {
      api.createRecord('364994ff', component.options)
    } else {
      api.reload('364994ff', component.options)
    }
    module.hot.accept("./AdminUsersEditBasicView.vue?vue&type=template&id=364994ff&scoped=true&", function () {
      api.rerender('364994ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/users/AdminUsersEditBasicView.vue"
export default component.exports